import { render, staticRenderFns } from "./CategoryTag.vue?vue&type=template&id=423e0a3c&scoped=true&lang=pug&"
import script from "./CategoryTag.vue?vue&type=script&lang=js&"
export * from "./CategoryTag.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTag.vue?vue&type=style&index=0&id=423e0a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e0a3c",
  null
  
)

export default component.exports